import WebApp from '@twa-dev/sdk';

import { makeLink } from '../../make-link';
import { isTMA } from '../is-tma';

export const openLink = (link: string) => {
  if (isTMA()) {
    WebApp.openTelegramLink(link);
    return;
  }

  const anchor = makeLink(link);
  anchor.click();
};
